import { useEffect, useState } from "react";
import { toast } from "sonner";

export default function AdminListings({ api, t }) {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(new Set());

  const load = () => {
    api.get("/admin/listings", { params: search ? { search } : {} }).then((r) => {
      setItems(r.data);
      setSelected(new Set());
    });
  };
  useEffect(() => { load(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);

  const toggle = (id) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  };

  const selectAll = () => setSelected(new Set(items.map((l) => l.id)));
  const clearSel = () => setSelected(new Set());

  const toggleHidden = async (l) => {
    await api.patch(`/admin/listings/${l.id}`, { hidden: !l.hidden });
    setItems((arr) => arr.map((x) => x.id === l.id ? { ...x, hidden: !l.hidden } : x));
    toast.success(t("admin.actionOk"));
  };

  const remove = async (l) => {
    if (!confirm(t("admin.confirmDelete"))) return;
    await api.delete(`/admin/listings/${l.id}`);
    setItems((arr) => arr.filter((x) => x.id !== l.id));
    toast.success(t("admin.actionOk"));
  };

  const runBulk = async (action) => {
    if (selected.size === 0) return;
    if (action === "delete" && !confirm(t("admin.confirmDelete"))) return;
    const ids = Array.from(selected);
    const { data } = await api.post("/admin/listings/bulk", { ids, action });
    toast.success(t("admin.bulk.done", { n: data.affected }));
    if (action === "delete") {
      setItems((arr) => arr.filter((x) => !selected.has(x.id)));
    } else {
      const isHidden = action === "hide";
      setItems((arr) => arr.map((x) => selected.has(x.id) ? { ...x, hidden: isHidden } : x));
    }
    setSelected(new Set());
  };

  const allSelected = items.length > 0 && selected.size === items.length;

  return (
    <div>
      <div className="flex gap-2 mb-4">
        <input
          type="text"
          className="input-tech flex-1"
          placeholder={t("admin.listings.search")}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && load()}
          data-testid="admin-listings-search"
        />
        <button onClick={load} className="btn-ghost" data-testid="admin-listings-search-btn">{t("market.search")}</button>
      </div>

      {selected.size > 0 && (
        <div className="mb-4 p-3 bg-[var(--ink)] text-[var(--bone)] flex items-center gap-3 flex-wrap" data-testid="admin-bulk-bar">
          <span className="label-tech text-[var(--bone)]">{selected.size} {t("admin.bulk.selected")}</span>
          <button onClick={() => runBulk("hide")} className="btn-ghost text-xs" style={{ color: "var(--bone)", borderColor: "var(--bone)" }} data-testid="admin-bulk-hide">{t("admin.bulk.hide")}</button>
          <button onClick={() => runBulk("unhide")} className="btn-ghost text-xs" style={{ color: "var(--bone)", borderColor: "var(--bone)" }} data-testid="admin-bulk-unhide">{t("admin.bulk.unhide")}</button>
          <button onClick={() => runBulk("delete")} className="btn-primary text-xs" data-testid="admin-bulk-delete">{t("admin.bulk.delete")}</button>
          <button onClick={clearSel} className="label-tech text-[var(--bone)] ml-auto hover:underline" data-testid="admin-bulk-clear">{t("admin.bulk.clear")}</button>
        </div>
      )}

      <div className="flex items-center gap-3 mb-3">
        <label className="flex items-center gap-2 cursor-pointer label-tech">
          <input
            type="checkbox"
            checked={allSelected}
            onChange={() => (allSelected ? clearSel() : selectAll())}
            data-testid="admin-bulk-select-all"
          />
          {t("admin.bulk.selectAll")}
        </label>
      </div>

      <div className="divide-y divide-[var(--ink-200)]">
        {items.map((l) => (
          <div key={l.id} className="py-3 flex items-center gap-4" data-testid={`admin-listing-${l.id}`}>
            <input
              type="checkbox"
              checked={selected.has(l.id)}
              onChange={() => toggle(l.id)}
              data-testid={`admin-listing-checkbox-${l.id}`}
            />
            <div className="flex-1 min-w-0">
              <div className="font-display text-lg">{l.title} {l.hidden && <span className="tag tag-brick ml-2">{t("admin.hidden")}</span>}</div>
              <div className="label-tech mt-1">{l.seller_name} · {l.location} · {l.quantity} {l.unit} · {l.status}</div>
            </div>
            <button onClick={() => toggleHidden(l)} className="btn-ghost text-xs" data-testid={`admin-toggle-hidden-${l.id}`}>
              {l.hidden ? t("admin.unhide") : t("admin.hide")}
            </button>
            <button onClick={() => remove(l)} className="btn-ghost text-xs" data-testid={`admin-delete-listing-${l.id}`}>{t("admin.delete")}</button>
          </div>
        ))}
      </div>
    </div>
  );
}
